import { render, staticRenderFns } from "./LastIncidents.vue?vue&type=template&id=493cde3c&scoped=true"
import script from "./LastIncidents.vue?vue&type=script&lang=js"
export * from "./LastIncidents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493cde3c",
  null
  
)

export default component.exports